/**
 *   This is an experiment to measure the impact of batching events on the latency and in turn performance of web
 *   apps.
 */
export const EVENTS_BATCHING_LATENCY_AB_EXPERIMENT_240208 = 'EVENTS_BATCHING_LATENCY_AB_EXPERIMENT_240208';
